<template>
    <tile class="branches" link="branches">
        <div class="branches__header" slot="tileHeader">
            <tile-title icon="sitemap">Филиалы и представительства</tile-title>
            <app-switcher
                :leftClickHandler="changeType"
                :rightClickHandler="changeType"
            >
                <span slot="leftValue">ФНС</span>
                <span slot="rightValue">ГМЦ Росстата</span>
            </app-switcher>
        </div>
        
        <div class="brnaches__content" slot="tileContent">

            <app-transition
                :showLeftIf="currentType === 'fns'"
                :showRightIf="currentType === 'rosstat'"
            >
                <branches-table slot="left" type="fns" :list="fnsList.slice(0, 6)" />
                <branches-table slot="right" type="rosstat" :list="rosstatList.slice(0, 6)" />
            </app-transition>
            <branches-modal
                ref="modalRef"
                v-show="isModal"
                :list="modalList"
                :type="currentType"
                :title="title"
                :printStyle="printStyle"
                @close="closeModal" 
            />
        </div>

        <div :class="{ 'flex-end': totalCount <= 6 }" class="branches__footer" slot="tileFooter">
            <tile-button @click.native="openModal" v-if="totalCount > 6">Филиалы и представительства <span v-if="auth">({{totalCount}})</span></tile-button>
            <tile-print-pdf
                filename="Branches"
                :html="htmlContent"
                :printStyle="printStyle"
                :title="title"
            />
        </div>
    </tile>
</template>

<script>
import tile from '@/components/ui/tile/tile.vue'
import appSwitcher from '@/components/ui/appSwitcher/appSwitcher.vue'
import tilePrintPdf from '@/components/ui/tilePrintPdf/tilePrintPdf.vue'
import tileTitle from '@/components/ui/tileTitle/tileTitle.vue'
import appTransition from '@/components/ui/appTransition/appTransition.vue'
import tileButton from '@/components/ui/tileButton/tileButton.vue'
import branchesTable from '@/components/card/branches/branchesTable.vue'
import branchesModal from '@/components/card/branches/branchesModal.vue'

export default {
    components: {
        tile,
        appSwitcher,
        tilePrintPdf,
        tileTitle,
        tileButton,
        branchesTable,
        branchesModal,
        appTransition
    },
    data: () => ({
        currentType: 'fns',
        isModal: false,
        totalCount: 0,
        modalList: [],
        htmlContent: '',
        printStyle: `
            
            .branches-table { border-collapse: collapse; }
            .branches-table th { background: #ddddde }
            .branches-table td, .branches-table th { padding: 10px 20px; border: 1px solid #777778; border-collapse: collapse; }
            h4.title {
                font-size: 24px;
                line-height: 30px;
                margin: 15px 0;
                font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
                font-weight: 400;
                color: #444;
                text-transform: none;
            }
            .print-main-title { 
                    border-bottom: 1px solid #4b6365;
                    color: #4b6365;
                    font-size: 25px;
                    margin-top: 0px;
                    margin-bottom: 0px;
                    text-align: center;
                    margin-bottom: 15px;
                    margin-top: 20px; 
                }
        `
    }),
    computed: {
        fnsList() { return this.$store.state.card?.branches?.fns },
        rosstatList() { return this.$store.state.card?.branches?.rosstat },
        companyName() { return this.$store.state.card?.company?.name_short || this.$store.state.card?.company?.name_short },
        title() { return `Филиалы и представительства | ${this.companyName}` }
    },
    methods: {
        changeType() { this.currentType = this.currentType === 'fns' ? 'rosstat' : 'fns' },
        openModal() { this.isModal = true },
        closeModal() { this.isModal = false }
    },
    watch: {
        currentType() {
            if(this.currentType === 'fns') {
                this.totalCount = this.fnsList.length
                this.modalList = this.fnsList
            } else {
                this.totalCount = this.rosstatList.length
                this.modalList = this.rosstatList
            }
            setTimeout(() => {
                this.htmlContent = this.$refs.modalRef?.$refs?.htmlContent?.outerHTML
            }, 500)
        }
    },
    mounted() {
        this.$store.dispatch('card/branches/getBranches')
            .finally(() => {
                if(!this.fnsList?.length && !this.rosstatList?.length) {
                    $('#branches-tile').hide()
                    $('#tiles').trigger('resize')
                } else {
                    setTimeout(() => {
                        this.htmlContent = this.$refs.modalRef?.$refs?.htmlContent?.outerHTML
                    }, 100)
                }
                this.totalCount = this.fnsList?.length
                this.modalList = this.fnsList
            })
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.branches
    &__header
        @include flex-between
    &__footer
        @include flex-between
.flex-end
    justify-content: flex-end
</style>